import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';

import Back from '../common/Back';

import PolicyDocumentRequestPage from './PolicyDocumentRequestPage';
import OtherRequestPage from './OtherRequestPage';
import CancelationRequestPage from './CancelationRequestPage';
import EndorsementsRequestPage from './EndorsementsRequestPage';
import ProposalComparisonRequestPage from './ProposalComparisonRequestPage';
import style from './RequestPage.module.css';

const RequestPage = React.memo(({ match }) => {
  const [clientInformation, setClientInformation] = useState({
    Name: '',
    ClientId: '',
  });

  const { clientId } = match.params;

  useEffect(() => {
    const handleClientInformationSuccess = ({ data }) => {
      setClientInformation(data);
    };

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}agency/clients/${clientId}/information`,
      )
      .then(handleClientInformationSuccess);
  }, [clientId]);

  const renderRequest = () => {
    switch (match.params.type) {
      case 'policy-document':
        return <PolicyDocumentRequestPage clientId={match.params.clientId} />;
      case 'other':
        return <OtherRequestPage clientId={match.params.clientId} />;
      case 'cancel':
        return <CancelationRequestPage clientId={match.params.clientId} />;
      case 'endorsement':
        return <EndorsementsRequestPage clientId={match.params.clientId} />;
      case 'proposal-comparison':
        return (
          <ProposalComparisonRequestPage clientId={match.params.clientId} />
        );
      default:
        return (
          <Redirect
            to={
              match.params.clientId ? `/clients/${match.params.clientId}` : '/'
            }
          />
        );
    }
  };

  return (
    <div className={style.request}>
      <Back
        path={`/clients/${match.params.clientId}`}
        text={clientInformation.Name}
        clientId={`${clientInformation.ClientId}`}
      />
      {renderRequest()}
    </div>
  );
});

RequestPage.propTypes = {};

export default RequestPage;
